/** @type {HTMLDivElement|null} */
let overlay = null;

/**
 * Create a container and set the full-size image as its background
 * @param {HTMLImageElement} image
 * @returns {HTMLDivElement}
 */
function createOverlay(image) {
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', `${image.src}`);
  overlay = document.createElement('div');
  prepareOverlay(overlay, overlayImage);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    if (image.parentElement && overlay) {
      image.parentElement.insertBefore(overlay, image);
    }
    image.style.opacity = '100%';
  };

  return overlay;
}

/**
 * @param {HTMLDivElement} container
 * @param {HTMLImageElement} image
 */
function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
}

/**
 * @param {HTMLImageElement} image
 */
function toggleLoadingSpinner(image) {
  const parentElement = image.parentElement;
  if (!parentElement || !parentElement.parentElement) {return;}
  const loadingSpinner = /** @type {HTMLElement|null} */ (
    parentElement.parentElement.querySelector(`.loading-overlay__spinner`)
  );
  if (loadingSpinner) {
    loadingSpinner.classList.toggle('hidden');
  }
}

/**
 * @param {HTMLImageElement} image
 * @param {MouseEvent} event
 * @param {number} zoomRatio
 */
function moveWithHover(image, event, zoomRatio) {
  // calculate mouse position
  const ratio = image.height / image.width;
  const target = /** @type {HTMLElement} */ (event.target);
  const container = target.getBoundingClientRect();
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

  // determine what to show in the frame
  if (overlay) {
    overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
    overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
  }
}

/**
 * @param {HTMLImageElement} image
 * @param {number} zoomRatio
 */
function magnify(image, zoomRatio) {
  const overlayEl = createOverlay(image);
  overlayEl.onclick = () => overlayEl.remove();
  overlayEl.onmousemove = (event) => moveWithHover(image, event, zoomRatio);
  overlayEl.onmouseleave = () => overlayEl.remove();
}

/**
 * @param {number} zoomRatio
 */
function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((element) => {
    const image = /** @type {HTMLImageElement} */ (element);
    image.onclick = (event) => {
      magnify(image, zoomRatio);
      moveWithHover(image, event, zoomRatio);
    };
  });
}

enableZoomOnHover(2);
